import { useFormik } from "formik";
import { InfoObligacionDTO, ObligacionDTO, ObligacionForm, TipoObligacionDTO, VoidInfoObligacionDTO, VoidObligacionDTO } from "../../interfaces/Deudas/DeudasDTO";
import { Alert, Autocomplete, Button, Checkbox, CircularProgress, Container, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, FormHelperText, FormLabel, Grid, IconButton, Input, InputAdornment, InputLabel, MenuItem, Radio, RadioGroup, Select, TextField, Typography } from "@mui/material";
import { FaDownload, FaFileInvoiceDollar, FaRegSave, FaRegWindowClose } from "react-icons/fa";
import { useEffect, useState } from "react";
import { PersonaGrupo } from "../../interfaces/Grupos/GruposDTO";
import GrupoService from "../../services/GrupoService";
import { TbSearch } from "react-icons/tb";
import AlertService from "../../services/AlertService";
import { setFileModelWithName } from "../../interfaces/FileModel";
import { PiCertificateBold } from "react-icons/pi";
import { GrArticle } from "react-icons/gr";
import { useNavigate } from "react-router-dom";
import { DeudasPersonaSchemaPost, DeudasPersonaSchemaUpd } from "../ValidationForm/validationForm";
import FondoRotativoService from "../../services/FondoRotativoService";
import { MdCurrencyExchange } from "react-icons/md";
import ConsultasService from "../../services/ConsultaService";

// const grupoService = new GrupoService();
const consultaService = new ConsultasService();
const alertService = new AlertService();
const fondos = new FondoRotativoService();

interface Props {
    obligacion: ObligacionDTO,
    token: string,
    idcreador: number,
    Post: (dataRespuesta: any) => void;
    Put: (dataRespuesta: any) => void;
}

const boxStyle = {
    border: "1px solid #ccc",
    borderRadius: "12px",
    padding: 2,
    marginTop: 1
};

const labelStyle = {
    fontSize: "1.5rem",
    display: "flex",
    alignItems: "center",
    gap: "6px"
};

export const FormularioDeudas: React.FC<Props> = ({ token, idcreador, obligacion, Post, Put }) => {
    const [modo, setModo] = useState('E');
    const [personas, setPersonas] = useState<Array<PersonaGrupo>>([]);
    const [loadingPer, setLoadingPer] = useState(false);
    const [readOnly, setReadOnly] = useState(false);
    const [openAutocomplete, setOpenAutocomplete] = useState(false);
    const [busquedaParametro, setBusquedaParametro] = useState('');
    const [docpago, setDocpago] = useState(VoidInfoObligacionDTO());
    const [certpart, setCertpart] = useState(VoidInfoObligacionDTO());
    const [artcient, setArtcient] = useState(VoidInfoObligacionDTO());
    const [tiposObligaciones, setTiposObligaciones] = useState<Array<TipoObligacionDTO>>([])
    const [open, setOpen] = useState(false);
    const [temp, setTemp] = useState<ObligacionDTO>(VoidObligacionDTO());
    let history = useNavigate();

    useEffect(() => {
        if (obligacion.iddecinvobligacion > 0) {
            obligacion.infoobligaciondtos?.forEach((item) => {
                switch (item.detalle) {
                    case "DOC_PAGO":
                        setDocpago({
                            iddecinvinfoobligacion: item.iddecinvinfoobligacion,
                            archivocontenido: item.archivocontenido,
                            refarchivo: item.refarchivo,
                            descripcion: item.descripcion,
                            detalle: item.detalle,
                            obligatorio: item.obligatorio,
                            textoObligatorio: item.textoObligatorio,
                        });
                        break;

                    case "CERT_PART":
                        setCertpart({
                            iddecinvinfoobligacion: item.iddecinvinfoobligacion,
                            archivocontenido: item.archivocontenido,
                            refarchivo: item.refarchivo,
                            descripcion: item.descripcion,
                            detalle: item.detalle,
                            obligatorio: item.obligatorio,
                            textoObligatorio: item.textoObligatorio,
                        });
                        break;

                    case "ART_CIENT":
                        setArtcient({
                            iddecinvinfoobligacion: item.iddecinvinfoobligacion,
                            archivocontenido: item.archivocontenido,
                            refarchivo: item.refarchivo,
                            descripcion: item.descripcion,
                            detalle: item.detalle,
                            obligatorio: item.obligatorio,
                            textoObligatorio: item.textoObligatorio,
                        });
                        break;
                }
            });
        }
    }, []);

    const CloseDialog = () => {
        setTemp(VoidObligacionDTO())
        setOpen(false);
    }

    const debugFormik = async () => {

        // fuerza validación
        const errors = await formik.validateForm();

        // marca todo como touched
        const touchedFields = Object.keys(formik.values).reduce(
            (acc, key) => {
                acc[key] = true;
                return acc;
            },
            {} as Record<string, boolean>
        );

        formik.setTouched(touchedFields);

        console.log("============== FORMIK DEBUG ==============");

        console.log("ERRORS:");
        console.log(errors);

        console.log("TOUCHED:");
        console.log(formik.touched);

        console.log("==========================================");
    };
    const GetTipos = async () => {
        await fondos.GetTiposObligaciones(token)
            .then((data) => {
                //console.log(data)
                setTiposObligaciones(data.listData)
            })
            .catch((error) => console.error(error));
    };

    // 🔹 Convertir archivo a base64
    const fileToBase64 = (
        file?: File | Blob | string | null
    ): Promise<string | null> => {
        return new Promise((resolve, reject) => {
            if (!file) {
                resolve(null);
                return;
            }

            if (typeof file === "string") {
                resolve(file);
                return;
            }

            if (!(file instanceof Blob)) {
                resolve(null);
                return;
            }

            const reader = new FileReader();

            reader.onload = () => {
                resolve(reader.result as string);
            };

            reader.onerror = (error) => {
                reject(error);
            };

            reader.readAsDataURL(file);
        });
    };

    // 🔹 Crear un InfoObligacionDTO (genérico)
    const createInfo = async (
        id: number,
        selected: boolean,
        file: any,
        descripcion: string,
        detalle: string
    ): Promise<InfoObligacionDTO | null> => {
        if (!selected) return null;
        let archivoContenido: string | null = null;
        let refArchivo = "";

        if (file instanceof File) {
            archivoContenido = await fileToBase64(file);
            refArchivo = file.name;
        }
        else if (file && typeof file === "object" && file.content) {
            archivoContenido = file.content;
            refArchivo = file.fileName || "";
        }
        else if (typeof file === "string") {
            archivoContenido = file;
        }
        return {
            iddecinvinfoobligacion: id ?? 0,
            archivocontenido: archivoContenido,
            refarchivo: "",
            descripcion: descripcion || "",
            detalle: detalle,
            obligatorio: "S",
            textoObligatorio: "Sí"
        };
    };

    // 🔹 Construir array de InfoObligacionDTO
    const buildInfoObligaciones = async (values: any): Promise<InfoObligacionDTO[]> => {
        const items = await Promise.all([
            createInfo(values.iddecinvinfoobligacionDocPago, values.selectDocpago, values.docpago, values.docpagoDescp, "DOC_PAGO"),
            createInfo(values.iddecinvinfoobligacionCertpart, values.selectCertpart, values.certpart, values.certpartDescp, "CERT_PART"),
            createInfo(values.iddecinvinfoobligacionArtcient, values.selectArtcient, values.artcient, values.artcientDescp, "ART_CIENT"),
        ]);

        return items.filter(Boolean) as InfoObligacionDTO[];
    };

    // 🔹 Mapper principal a ObligacionDTO
    const mapToObligacionDTO = async (values: any): Promise<ObligacionDTO> => {
        return {
            iddecinvobligacion: values.idInvObligacion,
            idpersona: values.idpersona,
            nombreInvestigador: values.nombrecompleto,
            nombreUnidad: values.nombreUnidad,
            idcustodio: idcreador,
            nombreCustodio: "",

            iddecinvtipoobligacion: values.idInvTipoObligacion,
            nombreTipoObligacion: "",

            estado: values.estado,
            textoEstado: "",

            fechalimite: values.fechaLimite,
            fechaliberacion: null as any,

            idliberador: 0,
            nombreLiberador: "",

            fecharegistro: values.fechaIngreso,

            infoobligaciondtos: await buildInfoObligaciones(values)
        };
    };

    const mapInfoToFormik = (items: any[]) => {
        const result = {
            iddecinvinfoobligacionDocPago: 0,
            selectDocpago: false,
            docpago: null,
            docpagoDescp: "",
            iddecinvinfoobligacionCertpart: 0,
            selectCertpart: false,
            certpart: null,
            certpartDescp: "",
            iddecinvinfoobligacionArtcient: 0,
            selectArtcient: false,
            artcient: null,
            artcientDescp: ""
        };

        items?.forEach((item) => {
            switch (item.detalle) {
                case "DOC_PAGO":
                    result.iddecinvinfoobligacionDocPago = item.iddecinvinfoobligacion ?? 0;
                    result.selectDocpago = item.obligatorio === "S";
                    result.docpago = item.iddecinvinfoobligacion ? item : null;
                    result.docpagoDescp = item.descripcion || "";
                    break;

                case "CERT_PART":
                    result.iddecinvinfoobligacionCertpart = item.iddecinvinfoobligacion ?? 0;
                    result.selectCertpart = item.obligatorio === "S";
                    result.certpart = item.iddecinvinfoobligacion ? item : null;
                    result.certpartDescp = item.descripcion || "";
                    break;

                case "ART_CIENT":
                    result.iddecinvinfoobligacionArtcient = item.iddecinvinfoobligacion ?? 0;
                    result.selectArtcient = item.obligatorio === "S";
                    result.artcient = item.iddecinvinfoobligacion ? item : null;
                    result.artcientDescp = item.descripcion || "";
                    break;
            }
        });

        return result;
    };

    const mappedInfo = mapInfoToFormik(obligacion.infoobligaciondtos || []);

    const formik = useFormik<ObligacionForm>({
        initialValues: {
            idInvObligacion: obligacion.iddecinvobligacion,
            idpersona: obligacion.idpersona,
            idInvTipoObligacion: obligacion.iddecinvtipoobligacion,
            fechaIngreso: obligacion.fecharegistro,
            fechaLimite: obligacion.fechalimite,
            estado: obligacion.estado,
            numeroidentificacion: '',
            nombrecompleto: obligacion.nombreInvestigador,
            email: '',
            archivos: obligacion.infoobligaciondtos,
            ...mappedInfo
        },
        validationSchema: obligacion.iddecinvobligacion === 0 ? DeudasPersonaSchemaPost : DeudasPersonaSchemaUpd,
        onSubmit: async (values: ObligacionForm) => {
            try {
                const payload = await mapToObligacionDTO(values);
                //console.log(values)
                if (values.idInvObligacion === 0) {
                    await Post(payload);
                } else {
                    payload.idcustodio = obligacion.idcustodio
                    payload.idliberador = idcreador
                    payload.fechaliberacion = new Date();
                    payload.estado = 'L';
                    setTemp(payload);
                    setOpen(true);
                }
            } catch (error) {
                console.error("Error en submit:", error);
            }
        }
    });

    const goToNavigation = (site: string) => {
        history(site)
    }

    const PersonaEspol = async () => {
        if (busquedaParametro.length >= 3) {
            setLoadingPer(true);
            try {
                await consultaService.PersonasByNombre(modo, busquedaParametro, token)
                    .then((data) => {
                        if (data.status.isSuccessfully) {
                            setPersonas(data.listData)
                            if (data.listData.length > 0) {
                                setOpenAutocomplete(true);
                            } else {
                                setOpenAutocomplete(false);
                            }
                        } else {
                            console.error(data.status.messages)
                        }
                    }).finally(() => {
                        setLoadingPer(false);
                    }
                    )
            } catch (error) {
                console.error("Error al obtener personas:", error);
                setLoadingPer(false);
            }
        }
    };

    const handleKeyDownBusqueda = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "Enter") {
            event.preventDefault(); // evita enviar el formulario
            //console.log("Presionó Enter. Buscar:", event.currentTarget.value);
            PersonaEspol(); // por ejemplo
        }
    };

    function OpenArchivo(archivo: InfoObligacionDTO) {
        if (archivo.iddecinvinfoobligacion > 0) {
            window.open(linkDspace(archivo.refarchivo), '_blank');
        }
    }

    function linkDspace(ideref: string): string {
        if (ideref === '' || ideref === null) {
            return '';
        }
        let listaArray: string[] = ideref.split(",");
        let enlace = 'http://192.168.1.125/rest/bitstreams/{ideref}/retrieve';
        enlace = enlace.replace("{ideref}", listaArray[1]);
        return enlace;
    }

    useEffect(() => {
        GetTipos()
    }, []);

    return (
        <Container maxWidth="lg" style={{ padding: '20px', borderTopWidth: '3px', textAlign: 'center' }}>
            <form onSubmit={formik.handleSubmit}>
                <Grid container direction={'row'} spacing={1}>
                    {formik.values.idInvObligacion === 0 ?
                        <>
                            <Grid item xs={12} sm={12} md={12}>
                                <FormControl component="fieldset">
                                    <FormLabel component="legend">Buscar por</FormLabel>
                                    <RadioGroup
                                        row
                                        name="tipoBusqueda"
                                        value={modo}
                                        onChange={(e) => setModo(e.target.value as "N" | "E")}
                                    >
                                        <FormControlLabel
                                            value="N"
                                            control={<Radio />}
                                            label="Nombre"
                                        />
                                        <FormControlLabel
                                            value="E"
                                            control={<Radio />}
                                            label="Email"
                                        />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12}>
                                <FormControl sx={{ m: 1 }} fullWidth error={Boolean(formik.errors.nombrecompleto && formik.touched.nombrecompleto)}>
                                    <Autocomplete
                                        open={openAutocomplete}
                                        onOpen={() => setOpenAutocomplete(true)}
                                        onClose={() => setOpenAutocomplete(false)}
                                        freeSolo
                                        options={personas}
                                        getOptionLabel={(option) => {
                                            if (typeof option === "string") return option;
                                            return `${option.nombrecompleto} - ${option.email}`;
                                        }}
                                        filterOptions={(options) => options}
                                        value={null}
                                        inputValue={busquedaParametro}
                                        onInputChange={(event, newInputValue) => {
                                            setBusquedaParametro(newInputValue);
                                        }}
                                        onChange={(event, newValue) => {
                                            //console.log("Seleccionado:", newValue);
                                            if (newValue && typeof newValue !== "string") {
                                                formik.setFieldValue("idpersona", newValue.idpersona);
                                                formik.setFieldValue("nombrecompleto", newValue.nombrecompleto);
                                                formik.setFieldValue("email", newValue.email);
                                                formik.setFieldValue("numeroidentificacion", newValue.numeroidentificacion);
                                            }
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Búsqueda"
                                                onKeyDown={handleKeyDownBusqueda}
                                                disabled={readOnly}
                                                fullWidth
                                                InputProps={{
                                                    ...params.InputProps,
                                                    endAdornment: (
                                                        <>
                                                            {loadingPer && (
                                                                <InputAdornment position="end">
                                                                    <CircularProgress size={20} />
                                                                </InputAdornment>
                                                            )}
                                                            <InputAdornment position="end">
                                                                <IconButton
                                                                    onClick={PersonaEspol}
                                                                    disabled={readOnly || loadingPer || !busquedaParametro?.trim()}
                                                                >
                                                                    <TbSearch />
                                                                </IconButton>
                                                            </InputAdornment>
                                                            {params.InputProps.endAdornment}
                                                        </>
                                                    ),
                                                }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                        </>
                        : <></>}
                    <Grid item xs={12} sm={12} md={12} lg={formik.values.idInvObligacion > 0 ? 12 : 4}>
                        <FormControl sx={{ m: 1 }} fullWidth error={Boolean(formik.errors.nombrecompleto && formik.touched.nombrecompleto)}>
                            <TextField
                                fullWidth
                                id="nombrecompleto"
                                name="nombrecompleto"
                                label="Nombre"
                                value={formik.values.nombrecompleto}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.nombrecompleto && Boolean(formik.errors.nombrecompleto)}
                                sx={{ marginBottom: '20px', width: '100%' }}
                                InputProps={{
                                    readOnly: true
                                }}
                            />
                            {formik.touched.nombrecompleto && formik.errors.nombrecompleto && (
                                <Alert severity="error">{formik.errors.nombrecompleto}</Alert>
                            )}
                        </FormControl>
                    </Grid>
                    {formik.values.idInvObligacion === 0 ?
                        <Grid item xs={12} sm={12} md={12} lg={4}>
                            <FormControl sx={{ m: 1 }} fullWidth error={Boolean(formik.errors.email && formik.touched.email)}>
                                <TextField
                                    fullWidth
                                    name="email"
                                    label="Correo"
                                    value={formik.values.email}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.email && Boolean(formik.errors.email)}
                                    sx={{ marginBottom: '20px', width: '100%' }}
                                    InputProps={{
                                        readOnly: true
                                    }}
                                />
                                {formik.touched.email && formik.errors.email && (
                                    <Alert severity="error">{formik.errors.email}</Alert>
                                )}
                            </FormControl>
                        </Grid>
                        : <></>}
                    {formik.values.idInvObligacion === 0 ?
                        <Grid item xs={12} sm={12} md={12} lg={4}>
                            <FormControl sx={{ m: 1 }} fullWidth error={Boolean(formik.errors.numeroidentificacion && formik.touched.numeroidentificacion)}>
                                <TextField
                                    fullWidth
                                    name="numeroidentificacion"
                                    label="Identificación"
                                    value={formik.values.numeroidentificacion}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.numeroidentificacion && Boolean(formik.errors.numeroidentificacion)}
                                    sx={{ marginBottom: '20px', width: '100%' }}
                                    InputProps={{
                                        readOnly: true
                                    }}
                                />
                                {formik.touched.numeroidentificacion && formik.errors.numeroidentificacion && (
                                    <Alert severity="error">{formik.errors.numeroidentificacion}</Alert>
                                )}
                            </FormControl>
                        </Grid>
                        : <></>}
                    <Grid item xs={12} sm={12} md={6}>
                        <FormControl sx={{ m: 1 }} fullWidth error={Boolean(formik.errors.idInvTipoObligacion && formik.touched.idInvTipoObligacion)} >
                            <InputLabel htmlFor="select-class">Tipo de deuda</InputLabel>
                            <Select
                                labelId="select-class"
                                name="idInvTipoObligacion"
                                label='Tipo de deuda'
                                variant="outlined"
                                value={formik.values.idInvTipoObligacion}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                sx={{ marginBottom: '20px', width: '100%' }}
                            >
                                <MenuItem value={0}>Seleccione Tipo de deuda</MenuItem>
                                {tiposObligaciones.map((tipo) => (
                                    <MenuItem key={tipo.iddecinvtipoobligacion} value={tipo.iddecinvtipoobligacion}>
                                        {tipo.nombre}
                                    </MenuItem>
                                ))}
                            </Select>
                            {formik.touched.idInvTipoObligacion && formik.errors.idInvTipoObligacion && (
                                <Alert severity="error">{formik.errors.idInvTipoObligacion}</Alert>
                            )}
                        </FormControl>
                    </Grid>
                    {formik.values.idInvObligacion > 0 && !formik.values.selectDocpago
                        ? <></>
                        :
                        <Grid container spacing={2} sx={{
                            border: "1px solid #ccc",
                            borderRadius: "12px",
                            padding: 2,
                            marginTop: 1
                        }}>
                            {
                                formik.values.idInvObligacion === 0 ?
                                    <Grid item xs={12} sm={12} md={6} lg={6}>
                                        <FormControl
                                            fullWidth
                                            error={Boolean(formik.touched.selectDocpago && formik.errors.selectDocpago)}
                                        >
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        name="selectDocpago"
                                                        checked={formik.values.selectDocpago}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                    />
                                                }
                                                label={
                                                    <span
                                                        style={{
                                                            fontSize: "1.5rem",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: "6px"
                                                        }}
                                                    >
                                                        <FaFileInvoiceDollar size={35} />
                                                        Documentos de Pago
                                                    </span>
                                                }
                                            />

                                            {/* {formik.touched.selectDocpago &&
                                            typeof formik.errors.selectDocpago === "string" && (
                                                <FormHelperText>
                                                    {formik.errors.selectDocpago}
                                                </FormHelperText>
                                            )} */}
                                        </FormControl>
                                    </Grid>
                                    :
                                    <>
                                        <Grid item xs={12} sm={12} md={5} lg={5}>
                                            <FormControl
                                                fullWidth
                                                error={Boolean(formik.touched.docpago && formik.errors.docpago)}
                                            >
                                                <InputLabel
                                                    shrink
                                                    sx={{
                                                        fontSize: "1.5rem",       // tamaño del texto
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "6px"
                                                    }}
                                                >
                                                    <FaFileInvoiceDollar size={35} />
                                                    Documentos de Pago
                                                </InputLabel>
                                                <Input
                                                    type="file"
                                                    // inputProps={{ accept: ".pdf" }}
                                                    onChange={async (e: React.ChangeEvent<HTMLInputElement>) => {
                                                        const file = e.target.files?.[0];
                                                        if (!file) return;
                                                        if (file.size > 8 * 1024 * 1024) {
                                                            alertService.alertaAdvertencia(
                                                                "Alerta",
                                                                "El tamaño máximo es 8 MB"
                                                            );
                                                            return;
                                                        }
                                                        const fileModel = await setFileModelWithName(file, "docpago");
                                                        formik.setFieldValue("docpago", fileModel);
                                                        formik.setFieldTouched("docpago", true);
                                                        await formik.validateField("docpago");
                                                    }}
                                                    onBlur={formik.handleBlur}
                                                />
                                                {formik.touched.docpago && typeof formik.errors.docpago === 'string' && (
                                                    <FormHelperText>
                                                        {formik.errors.docpago}
                                                    </FormHelperText>
                                                )}
                                                {formik.values.docpago && (
                                                    <FormHelperText>
                                                        Archivo seleccionado: {formik.values.docpago.fileName}
                                                    </FormHelperText>
                                                )}
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={1} lg={1}>
                                            <Button aria-label="archivo1" variant="contained" disabled={docpago.refarchivo === "" || docpago.refarchivo === null}
                                                color="error" startIcon={<FaDownload />} onClick={() => { OpenArchivo(docpago) }}>
                                                Ver
                                            </Button>
                                        </Grid>
                                    </>
                            }

                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <FormControl sx={{ m: 1 }} fullWidth error={Boolean(formik.errors.docpagoDescp && formik.touched.docpagoDescp)}>
                                    <TextField
                                        fullWidth
                                        name="docpagoDescp"
                                        label="Descripción:"
                                        rows={2}
                                        multiline
                                        placeholder="Especifique la deuda relacionada..."
                                        value={formik.values.docpagoDescp}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.docpagoDescp && Boolean(formik.errors.docpagoDescp)}
                                        sx={{ marginBottom: '20px', width: '100%' }}
                                    />
                                    {formik.touched.docpagoDescp && formik.errors.docpagoDescp && (
                                        <Alert severity="error">{formik.errors.docpagoDescp}</Alert>
                                    )}
                                </FormControl>
                            </Grid>
                        </Grid>
                    }
                    {formik.values.idInvObligacion > 0 && !formik.values.selectCertpart
                        ? <></>
                        :
                        <Grid container spacing={2} sx={{
                            border: "1px solid #ccc",
                            borderRadius: "12px",
                            padding: 2,
                            marginTop: 1
                        }}>
                            {
                                formik.values.idInvObligacion === 0 ?
                                    <Grid item xs={12} md={6}>
                                        <FormControl
                                            fullWidth
                                            error={Boolean(formik.touched.selectCertpart && formik.errors.selectCertpart)}
                                        >
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        name="selectCertpart"
                                                        checked={formik.values.selectCertpart}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                    />
                                                }
                                                label={
                                                    <span style={labelStyle}>
                                                        <PiCertificateBold size={35} />
                                                        Certificado Participación
                                                    </span>
                                                }
                                            />

                                            {/* {formik.touched.selectCertpart &&
                                            typeof formik.errors.selectCertpart === "string" && (
                                                <FormHelperText>
                                                    {formik.errors.selectCertpart}
                                                </FormHelperText>
                                            )} */}
                                        </FormControl>
                                    </Grid>
                                    :
                                    <>
                                        <Grid item xs={12} md={5}>
                                            <FormControl fullWidth>
                                                <InputLabel shrink sx={labelStyle}>
                                                    <PiCertificateBold size={35} />
                                                    Certificado Participación
                                                </InputLabel>

                                                <Input
                                                    type="file"
                                                    onChange={async (e: React.ChangeEvent<HTMLInputElement>) => {
                                                        const file = e.target.files?.[0];
                                                        if (!file) return;

                                                        if (file.size > 8 * 1024 * 1024) {
                                                            alertService.alertaAdvertencia("Alerta", "El tamaño máximo es 8 MB");
                                                            return;
                                                        }

                                                        const fileModel = await setFileModelWithName(file, "certpart");
                                                        formik.setFieldValue("certpart", fileModel);
                                                        formik.setFieldTouched("certpart", true);
                                                        await formik.validateField("certpart");
                                                    }}
                                                />

                                                {formik.values.certpart && (
                                                    <FormHelperText>
                                                        Archivo seleccionado: {formik.values.certpart.fileName}
                                                    </FormHelperText>
                                                )}
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={12} md={1}>
                                            <Button
                                                variant="contained"
                                                color="error"
                                                disabled={certpart.refarchivo === "" || certpart.refarchivo === null}
                                                startIcon={<FaDownload />}
                                                onClick={() => OpenArchivo(certpart)}
                                            >
                                                Ver
                                            </Button>
                                        </Grid>
                                    </>
                            }

                            <Grid item xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    name="certpartDescp"
                                    label="Descripción:"
                                    multiline
                                    rows={2}
                                    value={formik.values.certpartDescp}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.certpartDescp && Boolean(formik.errors.certpartDescp)}
                                />

                                {formik.touched.certpartDescp && formik.errors.certpartDescp && (
                                    <Alert severity="error">{formik.errors.certpartDescp}</Alert>
                                )}
                            </Grid>
                        </Grid>
                    }
                    {formik.values.idInvObligacion > 0 && !formik.values.selectArtcient
                        ? <></>
                        :
                        <Grid container spacing={2} sx={boxStyle}>
                            {
                                formik.values.idInvObligacion === 0 ?
                                    <Grid item xs={12} md={6}>
                                        <FormControl
                                            fullWidth
                                            error={Boolean(formik.touched.selectArtcient && formik.errors.selectArtcient)}
                                        >
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        name="selectArtcient"
                                                        checked={!!formik.values.selectArtcient}
                                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                            //console.log("valor:", e);
                                                            formik.setFieldValue("selectArtcient", e.target.checked);
                                                        }}
                                                        onBlur={formik.handleBlur}
                                                    />
                                                }
                                                label={
                                                    <span style={labelStyle}>
                                                        <GrArticle size={35} />
                                                        Artículo Científico
                                                    </span>
                                                }
                                            />

                                            {/* {formik.touched.selectArtcient &&
                                            typeof formik.errors.selectArtcient === "string" && (
                                                <FormHelperText>
                                                    {formik.errors.selectArtcient}
                                                </FormHelperText>
                                            )} */}
                                        </FormControl>
                                    </Grid>
                                    :
                                    <>
                                        <Grid item xs={12} md={5}>
                                            <FormControl fullWidth>
                                                <InputLabel shrink sx={labelStyle}>
                                                    <GrArticle size={35} />
                                                    Artículo Científico
                                                </InputLabel>

                                                <Input
                                                    type="file"
                                                    onChange={async (e: React.ChangeEvent<HTMLInputElement>) => {
                                                        const file = e.target.files?.[0];
                                                        if (!file) return;

                                                        if (file.size > 8 * 1024 * 1024) {
                                                            alertService.alertaAdvertencia("Alerta", "El tamaño máximo es 8 MB");
                                                            return;
                                                        }

                                                        const fileModel = await setFileModelWithName(file, "artcient");
                                                        formik.setFieldValue("artcient", fileModel);
                                                        formik.setFieldTouched("artcient", true);
                                                        await formik.validateField("artcient");
                                                    }}
                                                />

                                                {formik.values.artcient && (
                                                    <FormHelperText>
                                                        Archivo seleccionado: {formik.values.artcient.fileName}
                                                    </FormHelperText>
                                                )}
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={12} md={1}>
                                            <Button
                                                variant="contained"
                                                color="error"
                                                disabled={artcient.refarchivo === "" || artcient.refarchivo === null}
                                                startIcon={<FaDownload />}
                                                onClick={() => OpenArchivo(artcient)}
                                            >
                                                Ver
                                            </Button>
                                        </Grid>
                                    </>
                            }

                            <Grid item xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    name="artcientDescp"
                                    label="Descripción:"
                                    multiline
                                    rows={2}
                                    value={formik.values.artcientDescp}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.artcientDescp && Boolean(formik.errors.artcientDescp)}
                                />
                                {formik.touched.artcientDescp && formik.errors.artcientDescp && (
                                    <Alert severity="error">{formik.errors.artcientDescp}</Alert>
                                )}
                            </Grid>
                        </Grid>
                    }
                    <Grid item xs={12} md={12}>
                        {formik.touched.selectDocpago &&
                            typeof formik.errors.selectDocpago === "string" && (
                                <Alert severity="error">{formik.errors.selectDocpago}</Alert>
                            )}
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                        {formik.values.estado === 'L' ? 
                        <></>
                        :
                        <Button variant="contained" type="submit" color="success" startIcon={formik.values.idInvObligacion === 0 ? <FaRegSave /> : <MdCurrencyExchange />} onClick={debugFormik}>
                            {formik.values.idInvObligacion === 0 ? 'Registrar Deuda' : 'Liberar Deuda'}
                        </Button>
                        }                        
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                        <Button variant="contained" color="error" startIcon={<FaRegWindowClose />} onClick={() => goToNavigation('/Deudas')}>
                            Cancelar
                        </Button>
                    </Grid>
                </Grid>
            </form>
            <Dialog open={open} onClose={CloseDialog} maxWidth="md" fullWidth>
                <DialogTitle>Liberar</DialogTitle>

                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <Typography>¿Está seguro de que desea liberar esta deuda al investigador {obligacion.nombreInvestigador}?</Typography>
                        </Grid>
                    </Grid>

                </DialogContent>

                <DialogActions>
                    <Button variant="contained" type="submit" color="success" startIcon={<FaRegSave />} onClick={async () => { Put(temp); setOpen(false) }}>
                        Si
                    </Button>
                    <Button onClick={CloseDialog} variant="contained">
                        No
                    </Button>
                </DialogActions>
            </Dialog>
        </Container >
    );
}